import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Pagination from 'components/atoms/pagination';
import { ApplicationState } from 'store';
import { ConcurrentsState, SanctionsListType } from 'store/modules/concurrents_store/types';
import Loader from 'components/atoms/loader';
import moment from 'moment';
import 'moment/locale/pt-br';
import { Container } from './styles';

interface SanctionsAnalysisProps {
  paginate: any;
  currentPageSanctions: number;
}

const SanctionsAnalysis = (props: SanctionsAnalysisProps) => {
  const { paginate, currentPageSanctions } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const { concurrents, request } = useSelector<ApplicationState, ConcurrentsState>(
    (state) => state.session.concurrents,
  );

  const filteredSanctions = concurrents?.sanctions_list?.filter((sanction: SanctionsListType) => {
    const keyword = searchTerm.toLowerCase();
    return (
      sanction?.name_company?.toLowerCase().includes(keyword) ||
      sanction?.cnpj?.includes(keyword) ||
      sanction?.category?.toLowerCase().includes(keyword) ||
      sanction?.portal?.toLowerCase().includes(keyword)
    );
  });

  return (
    <Container>
      {request?.company?.loading ? (
        <p>Carregando informações...</p>
      ) : (
        <div>
          <div className="card card-list mt-2 p-3">
            <h6>Sanções:</h6>
            <div className="d-flex mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por palavra chave"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <ul className="list-group list-group-flush table-responsive mt-2">
              {request?.sanctions_list?.loading ? (
                <Loader />
              ) : (
                <table className="table table-hover table-resultados thead-dark">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Empresa</th>
                      <th scope="col">Orgão sancionador</th>
                      <th className="w-25" scope="col">
                        Sanção
                      </th>
                      <th scope="col">Data inicial</th>
                      <th scope="col">Data final</th>
                      <th scope="col">Arquivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {concurrents?.sanctions_list?.length === 0 ? (
                      <tr>
                        <td colSpan={4} className="text-center text-muted">
                          Não foram encontradas sanções para este CNPJ no Portal da Transparência.
                        </td>
                      </tr>
                    ) : (
                      filteredSanctions?.map((sanction: SanctionsListType) => (
                        <tr key={sanction?.id}>
                          <td>
                            <span>
                              {String(sanction?.cnpj)?.replace(
                                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                                '$1.$2.$3/$4-$5',
                              )}
                            </span>
                            <span>{sanction?.name_company?.toLocaleUpperCase()}</span>
                          </td>
                          <td>
                            <span>{sanction?.orgao_sancionador || '-'}</span>
                          </td>
                          <td>
                            <a
                              href={sanction?.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={
                                sanction?.available
                                  ? 'Acessar sanção no portal'
                                  : 'Sanção removida do portal'
                              }
                            >
                              <span>{sanction?.portal}</span>
                              <span>
                                <br />
                                {sanction?.category}
                              </span>
                            </a>
                          </td>
                          <td>
                            {sanction?.penalty_start_date
                              ? moment(sanction?.penalty_start_date).format('DD/MM/YYYY')
                              : '-'}
                          </td>
                          <td>
                            {sanction?.penalty_end_date
                              ? moment(sanction?.penalty_end_date).format('DD/MM/YYYY')
                              : '-'}
                          </td>
                          <td>
                            {sanction?.url ? (
                              <a
                                href={`https://conlicitacao-applications.s3.us-east-1.amazonaws.com/sancoes/${sanction.id}.pdf`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Baixar PDF página da publicação"
                              >
                                <i className="material-icons">download</i>
                              </a>
                            ) : (
                              <span>-</span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
              {concurrents?.total_pages_sanctions > 1 && (
                <div className="border rounded-bottom border-top-0 d-print-none">
                  <div className="row d-print-none">
                    <div className="col-md-12 px-4 mb-2">
                      <Pagination
                        postsPerPage={6}
                        totalPosts={concurrents?.total_pages_sanctions}
                        paginate={paginate}
                        currentPage={currentPageSanctions}
                        firstAndLastPage
                      />
                    </div>
                  </div>
                </div>
              )}
            </ul>
          </div>
        </div>
      )}
    </Container>
  );
};

export default SanctionsAnalysis;
